import { Component, OnInit } from '@angular/core';
import { DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import IPatientHasTreatment from '../../../_interfaces/IPatientHasTreatment';
import IPatient from '../../../_interfaces/IPatients';
import { CalendarAppointmentsWrapperComponent } from '../../calendar-appointments-wrapper/calendar-appointments-wrapper.component';

@Component({
  standalone: true,
  selector: 'app-calendar-quick-appointments',
  templateUrl: './calendar-quick-appointment.component.html',
  styleUrls: ['./calendar-quick-appointment.component.scss'],
  imports: [CalendarAppointmentsWrapperComponent],
})
export class CalendarQuickAppointmentComponent implements OnInit {
  public treatments: IPatientHasTreatment;
  public patient: IPatient;
  constructor(public config: DynamicDialogConfig) {}
  ngOnInit(): void {
    if (this.config) {
      this.patient = this.config.data.patient;
      this.treatments = this.config.data.treatments;
    }
  }
}
